export default __webpack_public_path__ + "1.17.10/static/media/close.b1d40998.svg";